import axios from 'axios';
import { API_URL } from '../config';

const API_BASE = `${API_URL}/api`;

export interface Favorite {
  id: number;
  userId: number;
  costumeId?: number;
  accessoryId?: number;
  createdAt: string;
  costume?: any;
  accessory?: any;
}

export class FavoriteService {
  static async getFavorites(token: string): Promise<Favorite[]> {
    const res = await axios.get(`${API_BASE}/favorites`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data.favorites;
  }

  static async addFavorite({ token, costumeId, accessoryId }: { token: string; costumeId?: number; accessoryId?: number; }) {
    try {
      console.log('🔐 FavoriteService.addFavorite - Token:', {
        tokenLength: token.length,
        tokenStart: token.substring(0, 20) + '...',
        costumeId,
        accessoryId,
        url: `${API_BASE}/favorites/add`
      });
      
      const res = await axios.post(`${API_BASE}/favorites/add`, { costumeId, accessoryId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('✅ FavoriteService.addFavorite - Success:', res.data);
      return res.data.favorite;
    } catch (error: any) {
      console.error('❌ FavoriteService.addFavorite - Error:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        tokenLength: token.length
      });
      throw error;
    }
  }

  static async removeFavorite({ token, costumeId, accessoryId }: { token: string; costumeId?: number; accessoryId?: number; }) {
    try {
      const res = await axios.post(`${API_BASE}/favorites/remove`, { costumeId, accessoryId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data;
    } catch (error) {
      console.error('Favori silme hatası:', error);
      throw error;
    }
  }
}

export default FavoriteService; 